import React, {useEffect, useState} from "react";
import SideBar from "../Navbars/SideBar";
import NavBar from "../Navbars/NavBar";
import {
    Dialog,
    Button,
    SearchInput, TrashIcon,
} from "evergreen-ui";
import {
    MDBAlert, MDBBtn,
    MDBCol, MDBIcon,
    MDBRow,
} from "mdbreact";
import {Card, Layout, Modal, Table, Tooltip} from "antd";
import {Text} from "react-font";
import { useList, useListVals } from 'react-firebase-hooks/database';
import Firebase from "../../Firebase";
import {useAuthState} from "react-firebase-hooks/auth";
import { useHistory } from 'react-router-dom';
import FireFetch from "../FireFetch";
import {useCollection} from "react-firebase-hooks/firestore";


const { Content } = Layout;
const db = Firebase.firestore();
var prodStoreRef = Firebase.storage().ref("System/Products");
const moment = require("moment");

const Logs = (props) => {

    const columns = [
        {
            title: 'Key',
            dataIndex: 'key',
            key: 'key',
        },
        {
            title: 'Outlet Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Location',
            dataIndex: 'location',
            key: 'location',
        },
        {
            title: 'Assigned',
            dataIndex: 'assigned',
            key: 'assigned',
        },{
            title: 'Time In',
            dataIndex: 'timeIn',
            key: 'timeIn',
        },{
            title: 'Time Out',
            dataIndex: 'timeOut',
            key: 'timeOut',
        },{
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
        },
    ];


    const [checkedData, setCheckedData] = useState(true);
    const callback = (data) => {
        setCheckedData(data);
    }
    const [users] = useCollection(
        db.collection('users'),
        {
            snapshotListenOptions: { includeMetadataChanges: true },
        }
    );
    const [outlets] = useCollection(
        db.collection('outlets'),
        {
            snapshotListenOptions: { includeMetadataChanges: true },
        }
    );
    const [logs, loading, error] = useCollection(
        db.collection('logs'),
        {
            snapshotListenOptions: { includeMetadataChanges: true },
        }
    );
    const [loggedInUser] = useAuthState(Firebase.auth());
    const [showAlert, setShowAlert] = useState(false);
    const [dataArray, setDataArray] = useState([]);
    const [logArray, setLogArray] = useState([]);
    const [color, setColor] = useState("info");
    const [message, setMessage] = useState("");


    useEffect(() => {
        if(loggedInUser){
            //console.log("logged in")
            if(error){
                alert(error.message);
            }

            var tempUseArray = [];
            var tempOutArray = [];
            if(users){
                users.docs.map((item) => {
                    var user = item.data();
                    tempUseArray.push(user);
                });
            }

            if(outlets){
                outlets.docs.map((item) => {
                    var outlet = item.data();
                    tempOutArray.push(outlet);
                });
            }

            if(logs){
                let filteredArray;
                let tempLogArray = [];
                logs.docs.map((item) => {
                    tempLogArray.push(item.data());
                })
                if(props.location.outlet === undefined){
                    filteredArray = tempLogArray;
                } else {
                    filteredArray = tempLogArray.filter(x => x.outletID === props.location.outlet);
                }

                var tempArray = [];
                filteredArray.map((log, index) => {

                    var usered = tempUseArray.filter(x => x.userID === log.userID)[0];
                    var outleted =  tempOutArray.filter(x => x.outletID === log.outletID)[0];
                    tempArray.push({
                        key: index + 1,
                        name: outleted.name,
                        location : log.userLocation.lat +","+log.userLocation.long,
                        assigned : usered.firstname + " " + usered.surname,
                        timeIn : moment(log.timeIn, "YYYY-MM-DDTh:mm").format("HH : mm"),
                        timeOut : moment(log.timeOut, "YYYY-MM-DDTh:mm").format("HH : mm"),
                        action: <div>
                            <Button intent="primary" onClick={() => {
                                // eslint-disable-next-line no-restricted-globals
                                if (confirm("Are you sure you want to delete Log?")) {
                                    deleteLog(log.logID);
                                }
                            }}>
                                <TrashIcon color="danger"/>
                            </Button>
                        </div>
                    });
                });

                setDataArray([...tempArray]);
                setLogArray([...tempArray]);
            }
        } else {
            //window.location.href = "/login";
        }

    }, [error, loggedInUser, logs, outlets, props.location.outlet, users]);


    const handleSearch = searchText => {
        const filteredEvents = logArray.filter(({ name }) => {
            name = name.toLowerCase();
            return name.includes(searchText);
        });

        setDataArray(filteredEvents);
    };

    const deleteLog = (logID) => {
        db.collection("tasks").doc(logID).delete()
            .then(() => {
                setMessage("Log deleted successfully");
                setColor("success");
                setShowAlert(true);
                setTimeout(() => {
                    setShowAlert(false);
                }, 3000);
        })
            .catch((error) => {
                setMessage("Unable to delete log, an error occurred :: " + error.message);
                setColor("danger");
                setShowAlert(true);
            });
    }


    return (

        <>

            <Layout style={{width: "100vw"}}>
                <SideBar checked={checkedData}/>
                <Layout className="site-layout">
                    <NavBar token={"token"} checkBack={callback}/>
                    <Content
                        className="site-layout-background"
                        style={{ margin: '10px 16px 15px'}}
                    >
                        <MDBRow className="w-100">
                            <MDBCol md={12}>

                                <Card className="w-100">

                                    <MDBRow>
                                        <MDBCol md={12} className="w-100">
                                            <div className="text-left">
                                                <div className="d-block">
                                                    <h5 className="font-weight-bold">
                                                        <Text family='Nunito'>
                                                            Outlet Logs
                                                        </Text>
                                                    </h5>
                                                </div>
                                            </div>

                                            <div className="d-flex flex-row align-items-center ml-1">
                                                <SearchInput height={40} placeholder="Search outlets" className="w-100"   onChange={e => handleSearch(e.target.value)} />
                                            </div>
                                        </MDBCol>

                                    </MDBRow>

                                </Card>

                                <Card>
                                    {showAlert?
                                        <>
                                            <MDBAlert color={color} className="my-3 font-italic" >
                                                {message}
                                            </MDBAlert>
                                        </>
                                        : null }
                                    <Card className="d-flex flex-column">
                                        <div>
                                            <Table style={{overflow: "auto"}} id={"dataTable"} loading={loading}
                                                   expandable={{
                                                       rowExpandable: true,
                                                   }}
                                                   dataSource={dataArray} columns={columns} />
                                        </div>
                                    </Card>
                                </Card>

                            </MDBCol>
                        </MDBRow>
                    </Content>
                </Layout>
            </Layout>

        </>
    )

}

export default Logs;
